import { signal } from '@preact/signals-react';
import jsonData from './jsonData';

const translations = signal({
	leftPanel: {
		map: {},
		exhibitionInfo: {},
		exhibitorList: {
			all: {},
			allExhibitors: {},
			search: {},
		},
		myFavorite: {},
		navigationPoints: {},
		endNavigation: {},
		recommendedRoutes: {},
		advancedSearch: {
			searchExhibitor: {},
			searchProduct: {},
			exhibitor: {},
			product: {},
			submit: {},
			selectAll: {},
			clearAll: {},
			noResult: {},
			restart: {},
		},
		downloadPrint: {
			singleFloor: {},
			allMaps: {},
			exhibitorList: {},
			exhibitorName: {},
			boothNumber: {},
			myFavorite: {},
			portrait: {},
			landscape: {},
		},
	},
	rightPanel: {
		language: {},
		floors: {},
		keys: {
			myFavorite: {},
			searchResult: {},
		},
	},
	exhibitorPopup: {
		booth: {},
		navigationPath: {},
		recommended: {},
		showMore: {},
	},
	mobile: {
		mapKeys: {},
	},
	print: {
		exhibitorList: {},
		exhibitorName: {},
		boothNumber: {},
		favorite: {},
	},
	map: {
		setNavigationPoint: {},
	},
	route: {
		cancelRoute: {},
		backToMap: {},
		routeName: {},
		stop: {},
		floorPassage: {},
		copyLink: {},
		copySummary: {},
		qrCode: {},
		routeSummary: {},
		exhibitionName: {},
		routeIntro: {},
	},
});

fetch('./translations.json')
	.then((response) => response.json())
	.then((data) => {
		console.log('translations', data);
		translations.value = data;
	})
	.catch(() => {
		alert('匯入翻譯資料錯誤');
	});

/**
 * 取一個翻譯字串。翻譯檔裡沒有這個 key 的時候回空字串，不要讓整個網站掛掉。
 *
 * 🔴 這幾個 if 不能省。
 *
 * 症狀：整個畫面一片白，什麼都沒有，console 只有一行
 * 「Cannot read properties of undefined (reading '')」。
 * 那個 '' 是還沒載入語言時的 currentLanguage.code，所以訊息裡完全看不出
 * 是「翻譯檔少了一個欄位」—— 看起來比較像程式壞了或資料檔壞了。
 *
 * 原因：這支是一路 result = result[keys[i]] 走下去的，中間少一層就變成 undefined，
 * 下一圈或最後那行取值當場丟例外。而 LeftPanel 在第一次 render 就會呼叫它，
 * 例外從最上層元件丟出來，React 就把整棵樹卸掉 —— 於是白畫面。
 *
 * 什麼時候會發生：前台加了新功能（多了新的翻譯 key），而客戶站上的 translations.json
 * 還是舊的那一份。2026-09-14 實測：目前程式用到 50 個 key，
 * 客戶 2025 年 EMO 那份線上翻譯檔少了 12 個（推薦路線、列印方向、路線分享那幾組），
 * 拿它配現在的程式就是白畫面。
 *
 * 少一個欄位該有的樣子是「那顆按鈕沒有文字」，不是「整個網站打不開」。
 */
const translation = (key) => {
	const keys = key.split('.');
	let result = translations.value;

	for (let i = 0; i < keys.length; i++) {
		if (!result || typeof result !== 'object') return '';
		result = result[keys[i]];
	}

	if (!result || typeof result !== 'object') return '';

	return result[jsonData.value.currentLanguage?.code] || '';
};

export default translation;
